/**
 * Classe em `<html>` durante telas auth: alinha `body`/`#root` com o mesmo fundo que a status bar
 * (PWA `viewport-fit=cover`, `black-translucent`). Removida no unmount do {@link AuthLayout}.
 */
export const AUTH_LAYOUT_HTML_CLASS = 'auth-layout-active';

/**
 * Alturas da logo nas telas auth (login, onboarding, planos, etc.).
 * Só utilitários **`h-*`** (e breakpoints): a largura vem da proporção da imagem (`w-auto` no {@link AppLogo}).
 */
export const AUTH_LAYOUT_LOGO_RESPONSIVE_CLASS = 'h-12 sm:h-14 md:h-16 lg:h-18';
